import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@5.2.1@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_video_start",
  "use": "icon-icon_video_start-usage",
  "viewBox": "0 0 15 18",
  "content": "<symbol viewBox=\"0 0 15 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_video_start\">\n<path d=\"M13.2864 7.304C14.5397 8.08734 14.5397 9.91266 13.2864 10.696L3.05999 17.0875C1.7279 17.9201 -7.8516e-07 16.9624 -7.16495e-07 15.3915L-1.57732e-07 2.6085C-8.90674e-08 1.03762 1.7279 0.0799378 3.06 0.912498L13.2864 7.304Z\" fill=\"#DCE0DF\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol